import { isArray } from 'util';
import { GraphicMenu } from '../graphic-menu';

export class GraphicMenuBuilder {
  static fromJson(json) {
    return (json)
      ? new GraphicMenu(
        json.hash,
        json.name,
        json.url
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(GraphicMenuBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/graphic-menu.builder.ts